import viewConfirmedOrder from './../components/viewPage.vue'
import store from '@/store'
// import orderConfirmed from '../components/orderConfirmed.vue'
import DeleteOrder from './../components/orderDelete.vue'
import verifyLog from './../components/verifyLog.vue'
import sentAtSearch from './../components/sentAtSearch.vue'
import orderStatus from '../components/orderStatus.vue'
import vue from 'vue'
const that = vue.prototype

export default {
  className: 'Order', // 审完成订单
  title: '审完成订单',
  mixin: {
    fields: [
      // {
      //   name: 'Number'
      // },
      {
        // 所属用户
        name: 'userid',
        note: '销售人员',
        width: 80,
        validators: [
          val => (val) ? null : '所属用户不可为空'
        ]
      },
      {
        name: 'userCompany',
        note: '所属公司',
        width: 80,
        validators: [
          val => (val) ? null : '所属公司不可为空'
        ]
      },
      {
        // 型号
        name: 'finishProductid',
        width: 80,
        validators: [
          val => (val) ? null : '成品型号不可为空'
        ]
      },
      {
        // 所属车间型号
        name: 'modelId',
        width: 80,
        note: '车间型号',
        render: (record) => {
          return `${record.finishProductid.model.name}`
        },
      },
      {
        // 包装
        name: 'packid',
        width: 80,
      },
      {
        // 托盘
        name: 'palletid',
        width: 80,
      },
      {
        // 状态
        name: 'status',
        width: 100,
        view: {
          component: orderStatus
        }
      },

      {
        name: 'verifyStatus',
        width: 100,
      },
      {
        // 麦头
        name: 'markid',
        width: 80,
      },
      {
        // 订单客户
        name: 'clientid',
        width: 110
      },
      {
        // 吨数
        name: 'amount',
        width: 80,
      },
      {
        // 运费
        name: 'shipping',
        width: 80,
      },
      {
        // 每吨运费
        name: 'pricePerTon',
        width: 100,
      },
      {
        // 售价
        name: 'sellingPrice',
        width: 80,
      },
      {
        // 成本
        name: 'costPrice',
        width: 80,
      },
      {
        // 客户提成
        name: 'clientCommission',
        width: 100,
      },
      {
        name: 'taxRate',
        width: 80,
      },
      {
        // 交付日期
        name: 'shipDate',

      },
      {
        // 利润
        name: 'profit',
        width: 80,
        validators: [
          val => (val) ? null : '利润不可为空'
        ],
        hidden: () => true
      },
      {
        // 发出时间
        name: 'sentAt',

        search: { // search中的其他参数，都会作为props传给自定义组件
          component: sentAtSearch
        },
        render: (record) => {
          if (Object.keys(record).indexOf('sentAt') !== -1) {
            let time = that.$tkDate(record.sentAt).format('yyyy-m')
            return time
          }
        },
      },

      {
        // 备注
        name: 'remarks',
        width: 80,
      },

      {
        // 提成
        name: 'commission',
        width: 80,
        validators: [
          val => (val) ? null : '提成不可为空'
        ],
        hidden: () => true
      },
    ],
  },
  search: [
    'userid',
    'userCompany',
    'finishProductid',
    'sentAt'
  ],
  action: {
    create: false,
    edit: false,
    view: store.state.user && store.state.user.authority.confirmedOrder.view ? {
      type: 'row',
      text: '查看',
      component: viewConfirmedOrder
    } : false,
    delete: false,
    myDelete: store.state.user && store.state.user.authority.confirmedOrder.del
      ? {
        type: 'row',
        text: '删除',
        component: DeleteOrder
      }
      : false,
    log: store.state.user && store.state.user.authority.confirmedOrder.log
      ? {
        type: 'row',
        text: '审核日志',
        title: '审核日志',
        component: verifyLog
      } : false
  },
  hooks: {
    async beforeFetch ({ where }) {
      if (where.sentAt === 'null') {
        delete where.sentAt
      }
      if (where && where.userCompany) {
        console.log(where)
        let res = await that.$tkParse.getData('/classes/_User', {
          params: {
            where: {
              company: where.userCompany
            }
          }
        })
        let target = []
        for (let i in res.results) {
          target.push(res.results[i].objectId)
        }
        delete where.userCompany
        where.userid = { $in: target }
      }
      // where.status = {
      // $in: ['confirmed', 'deliveriesTaked', 'transit']
      // }

      where.$or = [
        {
          verifyStatus: { $exists: false },
          status: 'finish'
        },
        {
          verifyStatus: 'secondVerify'
        }
      ]
      where.isReserve = { $ne: true }
      // where.verifyStatus = 'secondVerify'
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  }
}
